const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://lamdong-api.cgis.asia/",
  },
  production: {
      api: "https://lamdong-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
